<fab-loading-spinner color="primary" *ngIf="showSpinner"
                     id="loading-spinner"></fab-loading-spinner>
<div id="header-container">
  <div>
    <h1 id="header-text">Business Plan Portfolio Archive</h1>
  </div>
  <div>
    <button (click)="onUpdate()" class="action-button" color="primary"
            id="edit-button"
            [disabled]="!selectedRow"
            mat-flat-button>
      Update
    </button>
    <button (click)="onDelete()" class="action-button" color="warn"
            id="delete-button"
            [disabled]="!selectedRow"
            mat-raised-button>
      Delete
    </button>
    <button mat-flat-button color="primary" id="archive-button" class="action-button"
            (click)="onArchiveCurrentPortfolio()">
      Archive Current Portfolio
    </button>
  </div>
</div>
<div class="h-100">
  <div class="gfs-table">
    <ag-grid-angular
      style="height: 100%; width:100%;"
      class="ag-theme-quartz"
      [rowData]="archiveList"
      [columnDefs]="colDefinition"
      [autoSizeStrategy]="autoSizeStrategy"
      [rowSelection]="rowSelection"
      (rowSelected)="onSelect($event)"
      rowHeight="50"
    />
  </div>
</div>
